import { ChangeDetectionStrategy, Component, input, model, ViewEncapsulation } from '@angular/core';

export type TimepickerContainerVariant = 'flat' | 'elevated';
export type TimePeriod = 'AM' | 'PM';

@Component({
  selector: 'bspk-timepicker-container',
  imports: [],
  templateUrl: './timepicker-container.component.html',
  styleUrl: './timepicker-container.component.scss',
  encapsulation: ViewEncapsulation.None,
  host: {
    'data-bspk': 'timepicker-container',
    '[attr.data-variant]': 'variant()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BspkTimepickerContainer {
  readonly variant = input<TimepickerContainerVariant>('elevated');

  readonly hours = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  readonly minutes = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
  readonly periods = ['AM', 'PM'] as const;

  readonly hour = model<number | null>(null);
  readonly minute = model<number | null>(null);
  readonly period = model<TimePeriod>('PM');

  pad(value: number) {
    return value.toString().padStart(2, '0');
  }
}
